@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;
@use "~theme/colors.scss";
@use "sass:color";
@use "sass:math";

$modal-content-padding: 20px; // the gap between the modal and the modal content
$modal-content-top-padding: 28px;
$modal-gutter: 20px; // the gap between the modal and the screen edge
$dismiss-button-height: 32px; // approximate height of the dismiss button

.overlay {
  position: fixed;
  transform: translate(0, 0);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  background-color: color.adjust(colors.$black, $alpha: -0.2);
  z-index: var(--modal-overlay);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  position: relative;
  inset: 0;
  border: 1px solid var(--white);
  background-color: var(--white);
  border-radius: 4px;
  outline: none;
  padding: {
    top: $modal-content-top-padding;
    bottom: $modal-content-padding;
    left: $modal-content-padding;
    right: $modal-content-padding;
  };
  margin: {
    left: $modal-gutter;
    right: $modal-gutter;
    top: math.div($dismiss-button-height, 2) + $modal-gutter;
    bottom: $modal-gutter;
  };
  max-width: 430px;
  z-index: var(--modal);
  justify-content: center;
  flex: 1;
  overflow: visible;
  max-height: calc(100vh - #{$modal-gutter * 2 + $dismiss-button-height});
}

.modalContent {
  max-height: calc(100vh - #{$modal-gutter * 2 + $dismiss-button-height + $modal-content-top-padding + $modal-content-padding});
  overflow-x: visible;
  overflow-y: auto;
  margin-top: 20px;
}

.modalReviewContent {
  max-height: calc(100vh - 50px);
  overflow-x: visible;
  overflow-y: auto;
  margin-top: 20px;
}

.bodyOpenClassName nav {
  @include breakpoints.desktop {
    border-color: var(--black-at-75);
  }
}

.dismissButton {
  @include typography.body-semibold;
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  cursor: pointer;
  color: var(--white);
  z-index: var(--modal);
}

.dismissIcon {
  width: 14px;
  height: 14px;
  margin-left: 8px;
}

.closeContainer {
  position: absolute;
  right: 0px;
  img{
    width: 20px;
    height: 20px;
    margin-top: -60px;
    margin-right: 10px;
  }
}
